import React from 'react';
import { Button } from 'primereact/button';
import { IconPosition, PrimaryButtonProps } from './Button.types';

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  title,
  icon,
  iconPosition = 'left',
  className = '',
  type = 'button',
  onClick,
  disabled = false,
}) => {
  const defaultClasses =
    'flex justify-center gap-2 bg-primary px-[1em] min-h-12 min-w-fit text-black font-semibold rounded-[6px] transition-colors hover:bg-hoverColor hover:text-primary hover:outline hover:outline-4 hover:outline-primary transition duration-300 font-raleway';
  const mergedClasses = `${defaultClasses} ${className}`;

  return (
    <Button
      type={type}
      className={mergedClasses}
      onClick={onClick}
      aria-label={title || 'button'}
      disabled={disabled}
    >
      {icon && iconPosition === IconPosition.LEFT && icon}

      {title && <span>{title}</span>}

      {icon && iconPosition === IconPosition.RIGHT && icon}
    </Button>
  );
};

export default PrimaryButton;
